import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function putSirenaQuote(leadId, quote) {
  const response = await axios.put(`${REACT_APP_API}/sirena/quote/${leadId}/${quote.id}`,quote)
  return response
}